var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.5908H9.5V14.5908C9.5 14.3075 9.59583 14.07 9.7875 13.8783C9.97917 13.6867 10.2167 13.5908 10.5 13.5908H14.5C14.7833 13.5908 15.0208 13.6867 15.2125 13.8783C15.4042 14.07 15.5 14.3075 15.5 14.5908V19.5908H18.5V10.5908L12.5 6.09082L6.5 10.5908V19.5908ZM4.5 19.5908V10.5908C4.5 10.2742 4.57083 9.97415 4.7125 9.69082C4.85417 9.40749 5.05 9.17415 5.3 8.99082L11.3 4.49082C11.65 4.22415 12.05 4.09082 12.5 4.09082C12.95 4.09082 13.35 4.22415 13.7 4.49082L19.7 8.99082C19.95 9.17415 20.1458 9.40749 20.2875 9.69082C20.4292 9.97415 20.5 10.2742 20.5 10.5908V19.5908C20.5 20.1408 20.3042 20.6117 19.9125 21.0033C19.5208 21.395 19.05 21.5908 18.5 21.5908H14.5C14.2167 21.5908 13.9792 21.495 13.7875 21.3033C13.5958 21.1117 13.5 20.8742 13.5 20.5908V15.5908H11.5V20.5908C11.5 20.8742 11.4042 21.1117 11.2125 21.3033C11.0208 21.495 10.7833 21.5908 10.5 21.5908H6.5C5.95 21.5908 5.47917 21.395 5.0875 21.0033C4.69583 20.6117 4.5 20.1408 4.5 19.5908Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.f9c825a5cbc8808e4b3e02a4be546e2e.svg";
export { ForwardRef as ReactComponent };